
import { TipTap } from "../../common/TipTapEditor/TipTap";
import { editorLabelClassName } from "../../../common/editor/editorStyles";

export default function FieldText({ text, onChange }) {
	return (
		<div className="flex flex-col gap-2">
			<label className={editorLabelClassName}>متن مقاله</label>
			<p className="font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/50">
				تیتر، لیست، لینک، تصویر و نقل‌قول از نوار بالا در دسترس است.
			</p>
			<TipTap onChange={onChange} value={text} />
		</div>
	);
}
